import { memo, useEffect, useRef } from "react";
import { JitsiMeeting } from "@jitsi/react-sdk";
import { useTranslation } from "react-i18next";
import { attachMeetingRecovery, isMobileBrowser } from "./meetingRecovery";

const JITSI_DOMAIN = "room.xller.com";

// Jitsi embed that only re-renders when the room or name changes, so parent refreshes
// (e.g. polling the participant list) never reload an ongoing call. Keep the overwrite props
// constant outside the component, or memo stops helping.
function MeetingFrame({ roomName, displayName, height = 560, isHost = false, configOverwrite, interfaceConfigOverwrite }) {
    const { t } = useTranslation();
    const detachRecovery = useRef(null);

    useEffect(() => () => detachRecovery.current?.(), []);

    return (
        <>
            <JitsiMeeting
                domain={JITSI_DOMAIN}
                roomName={roomName}
                configOverwrite={{
                    prejoinConfig: { enabled: !isHost },
                    startWithAudioMuted: !isHost,
                    startWithVideoMuted: false,
                    enableEmailInStats: false,
                    ...configOverwrite,
                }}
                interfaceConfigOverwrite={interfaceConfigOverwrite}
                userInfo={{ displayName: displayName || "" }}
                onApiReady={(api) => {
                    detachRecovery.current?.();
                    detachRecovery.current = attachMeetingRecovery(api);
                }}
                getIFrameRef={(iframeRef) => { iframeRef.style.height = `${height}px`; iframeRef.style.width = "100%"; iframeRef.style.border = "0"; }}
            />
            {isMobileBrowser() && <p className="small text-muted mt-2 mb-0">{t("meetingFrame.keep_page_open")}</p>}
        </>
    );
}

export default memo(MeetingFrame);
